module.exports = __webpack_public_path__ + "static/media/NESTLEIND.abb87e90.txt";